module.exports = __webpack_public_path__ + "media/assets/images/blog/post-21marzo1-25-small-0ceb558590bc16ec95dfdac4097b6c1d.png";